import React from 'react';
const TabIcon = (props) => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>navigate_next</title>
            <path d="M9.984 6l6 6-6 6-1.406-1.406 4.594-4.594-4.594-4.594z"></path>
        </svg>
    );
}

export default TabIcon;



// WEBPACK FOOTER //
// ./src/components/Tabs/TabIcon.js